import {
  DetalleDoreSchema,
  OpcionesDoreSchema,
  PaginaDoreSchema,
  ResultadoDeCargaDoreSchema,
  type EdicionDore,
  type MovimientosDore,
  type NuevaExportacionDore,
} from '@cnc/contracts';
import {keepPreviousData, useMutation, useQuery, useQueryClient} from '@tanstack/react-query';
import {z} from 'zod';
import {json, pedir} from './cliente';
import {refrescarDatos} from './refrescar';

// Edicion y creacion en la app (decision 0094).
export function useOpcionesDore() {
  return useQuery({queryKey: ['dore', 'opciones'], queryFn: () => pedir('dore/opciones', OpcionesDoreSchema)});
}

export function useCrearDore() {
  const cliente = useQueryClient();
  return useMutation({
    mutationFn: (nueva: NuevaExportacionDore) => pedir('dore/exportaciones', DetalleDoreSchema, json('POST', nueva)),
    onSuccess: () => void cliente.invalidateQueries({queryKey: ['dore']}),
  });
}

export function useEditarDore(codigo: string) {
  const cliente = useQueryClient();
  return useMutation({
    mutationFn: (edicion: EdicionDore) =>
      pedir(`dore/exportaciones/${encodeURIComponent(codigo)}`, DetalleDoreSchema, json('PATCH', edicion)),
    onSuccess: () => void cliente.invalidateQueries({queryKey: ['dore']}),
  });
}

export function useMovimientosDore(codigo: string) {
  const cliente = useQueryClient();
  return useMutation({
    mutationFn: (movimientos: MovimientosDore) =>
      pedir(
        `dore/exportaciones/${encodeURIComponent(codigo)}/movimientos`,
        DetalleDoreSchema,
        json('PUT', movimientos),
      ),
    onSuccess: () => void cliente.invalidateQueries({queryKey: ['dore']}),
  });
}

export function useEliminarDore(codigo: string) {
  const cliente = useQueryClient();
  return useMutation({
    mutationFn: () =>
      pedir(
        `dore/exportaciones/${encodeURIComponent(codigo)}/eliminar`,
        z.object({eliminada: z.string()}),
        json('POST'),
      ),
    onSuccess: () => void cliente.invalidateQueries({queryKey: ['dore']}),
  });
}

// Dore (decision 0057): seguimiento de las exportaciones de dore.
export function useExportacionesDore(cadena: string) {
  return useQuery({
    queryKey: ['dore', 'exportaciones', cadena],
    queryFn: () => pedir(`dore/exportaciones${cadena ? `?${cadena}` : ''}`, PaginaDoreSchema),
    placeholderData: keepPreviousData,
  });
}

export function useDetalleDore(codigo: string) {
  return useQuery({
    queryKey: ['dore', 'detalle', codigo],
    queryFn: () => pedir(`dore/exportaciones/${encodeURIComponent(codigo)}`, DetalleDoreSchema),
  });
}

export function useCargarSeguimientoDore() {
  const cliente = useQueryClient();
  return useMutation({
    mutationFn: ({archivo, modo}: {archivo: File; modo: 'revisar' | 'aplicar'}) => {
      const cuerpo = new FormData();
      cuerpo.append('archivo', archivo, archivo.name);
      cuerpo.append('modo', modo);
      return pedir('dore/seguimiento/cargar', ResultadoDeCargaDoreSchema, {method: 'POST', body: cuerpo});
    },
    onSuccess: r => {
      if (r.aplicado) void refrescarDatos(cliente);
    },
  });
}
